import { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer";
import axios from "../../../axios";
import classes from "./customers.css"
import CustomerModal from "./CustomerModal/CustomerModal"

const columns = [
  { name: "Name", selector: "name", sortable: true, style: { fontSize: "15px" }},
  { name: "Representative", selector: "representative", sortable: true, left: true, style: { fontSize: "14px" }},
  { name: "VAT number", selector: "vatNumber", sortable: true, right: true, style: { fontSize: "14px" }},
  { name: "Country", selector: "country", sortable: true, right: true, style: { fontSize: "14px" }},
]

class Customers extends Component {

  state = {
    customers: [],
    selectedCustomer: null,
    showCustomerModal: false
  }


  componentDidMount() {
    this.loadCustomers()
  }

  loadCustomers = () => {
    axios.get("/customers/all")
      .then(response => {
        if (response.data) {
          this.setState({ customers: response.data })
        }
      })
  }

  closeModal = () => {
    // Close the modal in state
    this.setState({ showCustomerModal: false, selectedCustomer: null })

    // Refresh the list
    setTimeout(() => {
      this.loadCustomers()
    }, 500)
  }


  render() {
    return (
      <ContentContainer title="Klanten">
        <button onClick={() => this.setState({ showCustomerModal: true, selectedCustomer: null })} className={classes.addButton}>Add customer</button>
        <DataTable
          columns={columns}
          data={this.state.customers}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"name"}
          defaultSortAsc={false}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          onRowClicked={(customer) => this.setState({ showCustomerModal: true, selectedCustomer: customer })}
        />


        {this.state.showCustomerModal && <>
        <CustomerModal
          shouldShow={this.state.showCustomerModal}
          selectedCustomer={this.state.selectedCustomer}
          closeModal={() => this.closeModal()}/>
        </>}

      </ContentContainer>
    );
  }
}

export default Customers;
